import React, { useState, useCallback } from "react";

const PRESSURE_LEVELS = [1000, 925, 850, 700, 500, 300, 250, 200];

const SURFACE_VARS = [
    { id: "msl", label: "MSLP" },
    { id: "t2", label: "Temp 2m" },
    { id: "windmag10", label: "Wind 10m" },
    { id: "apcp", label: "6-hr QPF" },
    { id: "apcptotal", label: "Total QPF" },
];

const PRESSURE_VARS = [
    { id: "t", label: "Temperature" },
    { id: "z", label: "Heights" },
    { id: "windmag", label: "Winds" },
    { id: "w", label: "Vert. Motion" },
    { id: "r", label: "Rel. Humidity" },
];

const VariableDropdowns = ({ selectedVarClass, selectedVariable, onSelectChange, isVarAvailable, selectedModel }) => {
    const [mode, setMode] = useState(() => {
        return SURFACE_VARS.some(v => v.id === selectedVariable) ? "surface" : "pressure";
    });

    const [activeSurface, setActiveSurface] = useState(() => {
        const found = SURFACE_VARS.find(v => v.id === selectedVariable);
        return found ? found.id : "msl";
    });

    const [activePressure, setActivePressure] = useState(() => {
        const found = PRESSURE_VARS.find(v =>
            PRESSURE_LEVELS.some(l => `${v.id}${l}` === selectedVariable)
        );
        return found ? found.id : "t";
    });

    const [levelIndex, setLevelIndex] = useState(() => {
        const idx = PRESSURE_LEVELS.findIndex(l =>
            selectedVariable.endsWith(String(l))
        );
        return idx >= 0 ? idx : 4;
    });

    const emit = useCallback((value, varClass) => {
        const syntheticEvent = { target: { value } };
        onSelectChange(syntheticEvent, "Variable", varClass);
    }, [onSelectChange]);

    const handleSurfaceClick = (varDef) => {
        setMode("surface");
        setActiveSurface(varDef.id);
        emit(varDef.id, varDef.label);
    };

    const handlePressureClick = (varDef) => {
        setMode("pressure");
        setActivePressure(varDef.id);
        emit(`${varDef.id}${PRESSURE_LEVELS[levelIndex]}`, varDef.label);
    };

    const handleLevelChange = (e) => {
        const idx = parseInt(e.target.value, 10);
        setLevelIndex(idx);
        emit(`${activePressure}${PRESSURE_LEVELS[idx]}`, activePressure);
    };

    return (
        <div className="sidebar-section variable-section">
            <div className="sidebar-section-title">Surface</div>
            <div className="var-grid">
              {SURFACE_VARS.map((v) => {
                const available = isVarAvailable(v.id);
                console.log("Check:", v.id, "→", available);
                return (
                  <button
                    key={v.id}
                    disabled={!available}
                    title={!available ? `Not available for ${selectedModel}` : ""}
                    className={`var-btn ${
                      mode === "surface" && activeSurface === v.id ? "active" : ""
                    } ${!available ? "disabled" : ""}`}
                    onClick={() => {
                      if (!available) return;
                        handleSurfaceClick(v);
                    }}
                    >
                    {v.label}
                  </button>
                );
              })}
            </div>
            <div className="sidebar-section-title" style={{ marginTop: 16 }}>Pressure Level</div>
            <div className="var-grid">
              {PRESSURE_VARS.map((v) => {
                const fullVarId = `${v.id}${PRESSURE_LEVELS[levelIndex]}`;
                const available = isVarAvailable(fullVarId);
                console.log("Pressure check:", fullVarId, "→", available);

                return (
                  <button
                    key={v.id}
                    disabled={!available}
                    title={!available ? `Not available for ${selectedModel}` : ""}
                    className={`var-btn ${
                      mode === "pressure" && activePressure === v.id ? "active" : ""
                    } ${!available ? "disabled" : ""}`}
                    onClick={() => {
                      if (!available) return;
                        handlePressureClick(v);
                    }}
                    >
                   {v.label}
                  </button>
                );
              })}    
            </div>
            {mode === "pressure" && (
                <div className="level-control">
                    <div className="level-display">{PRESSURE_LEVELS[levelIndex]} hPa</div>
                    <input
                        type="range"
                        className="level-slider"
                        min={0}
                        max={PRESSURE_LEVELS.length - 1}
                        value={levelIndex}
                        onChange={handleLevelChange}
                    />
                    <div className="level-labels">
                        <span>1000</span>
                        <span>200</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default VariableDropdowns;
